import { z } from 'zod';
import { servicesProviderPricingFixedSchema, servicesProviderPricingFixedDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Pricing Schemas
// ============================================================================
const financingBrokerageServicePricingSchema = servicesProviderPricingFixedSchema;
const financingBrokerageServicePricingDtoSchema = servicesProviderPricingFixedDtoSchema;
// ============================================================================
// Core Schema
// ============================================================================
const financingBrokerageServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(financingBrokerageServicePricingSchema).optional(),
});
// ============================================================================
// DTO Schema
// ============================================================================
const financingBrokerageServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(financingBrokerageServicePricingDtoSchema).optional(),
});

export { financingBrokerageServiceConfigDtoSchema, financingBrokerageServiceConfigSchema, financingBrokerageServicePricingDtoSchema, financingBrokerageServicePricingSchema };
//# sourceMappingURL=FinancingBrokerageServiceConfig.js.map
